// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { SimulationFlowTransport } from "./simulation-flow-transport";
import { AdapterProtocol } from "../archive/adapter-protocol";

/**
 * One conversation found in a capture. The vendor side is the endpoint the
 * simulator impersonates: the target of the opening SYN, else the side on
 * the lower (server) port.
 */
export class SimulationCaptureFlow implements flatbuffers.IUnpackableObject<SimulationCaptureFlowT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationCaptureFlow {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationCaptureFlow(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationCaptureFlow,
  ): SimulationCaptureFlow {
    return (obj || new SimulationCaptureFlow()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSimulationCaptureFlow(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationCaptureFlow,
  ): SimulationCaptureFlow {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationCaptureFlow()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  /**
   * "ip:port" of the vendor device side.
   */
  vendorAddress(): string;
  vendorAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  vendorAddress(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  /**
   * "ip:port" of the host that talked to the device.
   */
  peerAddress(): string | null;
  peerAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  peerAddress(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  transport(): SimulationFlowTransport {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SimulationFlowTransport.TCP;
  }

  packetsFromVendor(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  packetsToVendor(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  bytesFromVendor(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  bytesToVendor(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  /**
   * Number of separate TCP streams (connections) in this flow.
   */
  tcpStreams(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * Offset of the flow's first packet from the start of the capture.
   */
  firstSeenMs(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  durationMs(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  /**
   * True when `detected_protocol` holds a decoder's verdict.
   */
  protocolDetected(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  detectedProtocol(): AdapterProtocol {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : AdapterProtocol.MCE;
  }

  static startSimulationCaptureFlow(builder: flatbuffers.Builder) {
    builder.startObject(12);
  }

  static addVendorAddress(builder: flatbuffers.Builder, vendorAddressOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, vendorAddressOffset, 0);
  }

  static addPeerAddress(builder: flatbuffers.Builder, peerAddressOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, peerAddressOffset, 0);
  }

  static addTransport(builder: flatbuffers.Builder, transport: SimulationFlowTransport) {
    builder.addFieldInt8(2, transport, SimulationFlowTransport.TCP);
  }

  static addPacketsFromVendor(builder: flatbuffers.Builder, packetsFromVendor: number) {
    builder.addFieldInt32(3, packetsFromVendor, 0);
  }

  static addPacketsToVendor(builder: flatbuffers.Builder, packetsToVendor: number) {
    builder.addFieldInt32(4, packetsToVendor, 0);
  }

  static addBytesFromVendor(builder: flatbuffers.Builder, bytesFromVendor: bigint) {
    builder.addFieldInt64(5, bytesFromVendor, 0n);
  }

  static addBytesToVendor(builder: flatbuffers.Builder, bytesToVendor: bigint) {
    builder.addFieldInt64(6, bytesToVendor, 0n);
  }

  static addTcpStreams(builder: flatbuffers.Builder, tcpStreams: number) {
    builder.addFieldInt32(7, tcpStreams, 0);
  }

  static addFirstSeenMs(builder: flatbuffers.Builder, firstSeenMs: bigint) {
    builder.addFieldInt64(8, firstSeenMs, 0n);
  }

  static addDurationMs(builder: flatbuffers.Builder, durationMs: bigint) {
    builder.addFieldInt64(9, durationMs, 0n);
  }

  static addProtocolDetected(builder: flatbuffers.Builder, protocolDetected: boolean) {
    builder.addFieldInt8(10, +protocolDetected, +false);
  }

  static addDetectedProtocol(builder: flatbuffers.Builder, detectedProtocol: AdapterProtocol) {
    builder.addFieldInt8(11, detectedProtocol, AdapterProtocol.MCE);
  }

  static endSimulationCaptureFlow(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // vendor_address
    return offset;
  }

  static createSimulationCaptureFlow(
    builder: flatbuffers.Builder,
    vendorAddressOffset: flatbuffers.Offset,
    peerAddressOffset: flatbuffers.Offset,
    transport: SimulationFlowTransport,
    packetsFromVendor: number,
    packetsToVendor: number,
    bytesFromVendor: bigint,
    bytesToVendor: bigint,
    tcpStreams: number,
    firstSeenMs: bigint,
    durationMs: bigint,
    protocolDetected: boolean,
    detectedProtocol: AdapterProtocol,
  ): flatbuffers.Offset {
    SimulationCaptureFlow.startSimulationCaptureFlow(builder);
    SimulationCaptureFlow.addVendorAddress(builder, vendorAddressOffset);
    SimulationCaptureFlow.addPeerAddress(builder, peerAddressOffset);
    SimulationCaptureFlow.addTransport(builder, transport);
    SimulationCaptureFlow.addPacketsFromVendor(builder, packetsFromVendor);
    SimulationCaptureFlow.addPacketsToVendor(builder, packetsToVendor);
    SimulationCaptureFlow.addBytesFromVendor(builder, bytesFromVendor);
    SimulationCaptureFlow.addBytesToVendor(builder, bytesToVendor);
    SimulationCaptureFlow.addTcpStreams(builder, tcpStreams);
    SimulationCaptureFlow.addFirstSeenMs(builder, firstSeenMs);
    SimulationCaptureFlow.addDurationMs(builder, durationMs);
    SimulationCaptureFlow.addProtocolDetected(builder, protocolDetected);
    SimulationCaptureFlow.addDetectedProtocol(builder, detectedProtocol);
    return SimulationCaptureFlow.endSimulationCaptureFlow(builder);
  }

  unpack(): SimulationCaptureFlowT {
    return new SimulationCaptureFlowT(
      this.vendorAddress(),
      this.peerAddress(),
      this.transport(),
      this.packetsFromVendor(),
      this.packetsToVendor(),
      this.bytesFromVendor(),
      this.bytesToVendor(),
      this.tcpStreams(),
      this.firstSeenMs(),
      this.durationMs(),
      this.protocolDetected(),
      this.detectedProtocol(),
    );
  }

  unpackTo(_o: SimulationCaptureFlowT): void {
    _o.vendorAddress = this.vendorAddress();
    _o.peerAddress = this.peerAddress();
    _o.transport = this.transport();
    _o.packetsFromVendor = this.packetsFromVendor();
    _o.packetsToVendor = this.packetsToVendor();
    _o.bytesFromVendor = this.bytesFromVendor();
    _o.bytesToVendor = this.bytesToVendor();
    _o.tcpStreams = this.tcpStreams();
    _o.firstSeenMs = this.firstSeenMs();
    _o.durationMs = this.durationMs();
    _o.protocolDetected = this.protocolDetected();
    _o.detectedProtocol = this.detectedProtocol();
  }

  unpackFields(...fields: string[]): SimulationCaptureFlowT {
    const t = new SimulationCaptureFlowT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("vendor_address")) {
      t.vendorAddress = this.vendorAddress();
    }
    if (fieldSet.has("peer_address")) {
      t.peerAddress = this.peerAddress();
    }
    if (fieldSet.has("transport")) {
      t.transport = this.transport();
    }
    if (fieldSet.has("packets_from_vendor")) {
      t.packetsFromVendor = this.packetsFromVendor();
    }
    if (fieldSet.has("packets_to_vendor")) {
      t.packetsToVendor = this.packetsToVendor();
    }
    if (fieldSet.has("bytes_from_vendor")) {
      t.bytesFromVendor = this.bytesFromVendor();
    }
    if (fieldSet.has("bytes_to_vendor")) {
      t.bytesToVendor = this.bytesToVendor();
    }
    if (fieldSet.has("tcp_streams")) {
      t.tcpStreams = this.tcpStreams();
    }
    if (fieldSet.has("first_seen_ms")) {
      t.firstSeenMs = this.firstSeenMs();
    }
    if (fieldSet.has("duration_ms")) {
      t.durationMs = this.durationMs();
    }
    if (fieldSet.has("protocol_detected")) {
      t.protocolDetected = this.protocolDetected();
    }
    if (fieldSet.has("detected_protocol")) {
      t.detectedProtocol = this.detectedProtocol();
    }
    return t;
  }
}

export class SimulationCaptureFlowT implements flatbuffers.IGeneratedObject {
  constructor(
    public vendorAddress: string | Uint8Array | null = null,
    public peerAddress: string | Uint8Array | null = null,
    public transport: SimulationFlowTransport = SimulationFlowTransport.TCP,
    public packetsFromVendor: number = 0,
    public packetsToVendor: number = 0,
    public bytesFromVendor: bigint = 0n,
    public bytesToVendor: bigint = 0n,
    public tcpStreams: number = 0,
    public firstSeenMs: bigint = 0n,
    public durationMs: bigint = 0n,
    public protocolDetected: boolean = false,
    public detectedProtocol: AdapterProtocol = AdapterProtocol.MCE,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.vendorAddress === null || this.vendorAddress === undefined) {
      throw new Error('Required field "vendor_address" is not set');
    }
    const vendorAddress =
      this.vendorAddress !== null ? builder.createString(this.vendorAddress!) : 0;
    const peerAddress = this.peerAddress !== null ? builder.createString(this.peerAddress!) : 0;

    return SimulationCaptureFlow.createSimulationCaptureFlow(
      builder,
      vendorAddress,
      peerAddress,
      this.transport,
      this.packetsFromVendor,
      this.packetsToVendor,
      this.bytesFromVendor,
      this.bytesToVendor,
      this.tcpStreams,
      this.firstSeenMs,
      this.durationMs,
      this.protocolDetected,
      this.detectedProtocol,
    );
  }

  clone(): SimulationCaptureFlowT {
    const obj = new SimulationCaptureFlowT();
    obj.vendorAddress = this.vendorAddress;
    obj.peerAddress = this.peerAddress;
    obj.transport = this.transport;
    obj.packetsFromVendor = this.packetsFromVendor;
    obj.packetsToVendor = this.packetsToVendor;
    obj.bytesFromVendor = this.bytesFromVendor;
    obj.bytesToVendor = this.bytesToVendor;
    obj.tcpStreams = this.tcpStreams;
    obj.firstSeenMs = this.firstSeenMs;
    obj.durationMs = this.durationMs;
    obj.protocolDetected = this.protocolDetected;
    obj.detectedProtocol = this.detectedProtocol;
    return obj;
  }

  equals(other: SimulationCaptureFlowT): boolean {
    if (this.vendorAddress !== other.vendorAddress) return false;
    if (this.peerAddress !== other.peerAddress) return false;
    if (this.transport !== other.transport) return false;
    if (this.packetsFromVendor !== other.packetsFromVendor) return false;
    if (this.packetsToVendor !== other.packetsToVendor) return false;
    if (this.bytesFromVendor !== other.bytesFromVendor) return false;
    if (this.bytesToVendor !== other.bytesToVendor) return false;
    if (this.tcpStreams !== other.tcpStreams) return false;
    if (this.firstSeenMs !== other.firstSeenMs) return false;
    if (this.durationMs !== other.durationMs) return false;
    if (this.protocolDetected !== other.protocolDetected) return false;
    if (this.detectedProtocol !== other.detectedProtocol) return false;
    return true;
  }
}

export function verifySimulationCaptureFlow(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "vendor_address");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 8);
    verifier.checkScalarField(tablePos, 16, 8);
    verifier.checkScalarField(tablePos, 18, 4);
    verifier.checkScalarField(tablePos, 20, 8);
    verifier.checkScalarField(tablePos, 22, 8);
    verifier.checkScalarField(tablePos, 24, 1);
    verifier.checkScalarField(tablePos, 26, 1);
  } finally {
    verifier.popDepth();
  }
}
